import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  loading: false,
  stores: [],
  error: "",
};

export const getStores = createAsyncThunk(
  "store/getStores",
  async (_, thunkApi) => {
    const { rejectedWithValue } = thunkApi;
    try {
      const res = await axios.get("/store/api/v1/stores-bulk/");
      const data = res.data;
      return data;
    } catch (err) {
      return rejectedWithValue(err);
    }
  },
);

const storeSlice = createSlice({
  name: "store",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getStores.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getStores.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      state.stores = action.payload;
    });
    builder.addCase(getStores.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export default storeSlice.reducer;
